import { ResponsiveContainer, AreaChart, Area, Tooltip, YAxis } from 'recharts';

const equityData = [
  { x: 0, v: 10000 }, { x: 1, v: 10200 }, { x: 2, v: 11800 },
  { x: 3, v: 13500 }, { x: 4, v: 15200 }, { x: 5, v: 18900 },
  { x: 6, v: 22400 }, { x: 7, v: 28100 }, { x: 8, v: 35600 },
  { x: 9, v: 48200 }, { x: 10, v: 72000 }, { x: 11, v: 95400 },
  { x: 12, v: 138000 }, { x: 13, v: 186000 }, { x: 14, v: 245000 },
  { x: 15, v: 220000 }, { x: 16, v: 287000 },
];

const fmt = (v: number) =>
  v >= 1000 ? `${(v / 1000).toFixed(0)}k` : `${v}`;

export default function PerformanceMetricsMock() {
  return (
    <div className="platform-mock mock-perf">
      <div className="platform-mock-header" style={{ justifyContent: 'space-between' }}>
        <span className="mock-perf-title">PERFORMANCE METRICS</span>
        <span className="mock-perf-close">&times;</span>
      </div>
      <div className="platform-mock-body">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '0.75rem' }}>
          <span className="mock-perf-subtitle">Historical simulation outcomes from 31 trades</span>
          <span className="mock-perf-disclaimer">Past performance does not predict future results</span>
        </div>

        <div className="mock-perf-grid" style={{ marginBottom: '0.75rem' }}>
          <div className="mock-perf-card">
            <div className="mock-perf-card-title">EQUITY PATH (HISTORICAL SIMULATION)</div>
            <div style={{ width: '100%', height: 100 }}>
              <ResponsiveContainer>
                <AreaChart data={equityData} margin={{ top: 4, right: 4, bottom: 0, left: 4 }}>
                  <defs>
                    <linearGradient id="eqFill" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#22c55e" stopOpacity={0.25} />
                      <stop offset="100%" stopColor="#22c55e" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <YAxis hide domain={['dataMin', 'dataMax']} />
                  <Tooltip
                    contentStyle={{ background: 'rgba(17,24,39,0.95)', border: '1px solid rgba(75,85,99,0.5)', borderRadius: 6, fontSize: 11, fontFamily: 'ui-monospace, monospace' }}
                    labelStyle={{ display: 'none' }}
                    formatter={(value: number) => [`$${fmt(value)}`, 'Equity']}
                    cursor={{ stroke: 'rgba(255,255,255,0.15)' }}
                  />
                  <Area type="monotone" dataKey="v" stroke="#22c55e" strokeWidth={1.5} fill="url(#eqFill)" dot={false} activeDot={{ r: 3, fill: '#22c55e' }} />
                </AreaChart>
              </ResponsiveContainer>
            </div>
            <div className="mock-perf-chart-caption">Shape illustrates return concentration and recovery behaviour</div>
          </div>

          <div className="mock-perf-card">
            <div className="mock-perf-card-title">OUTCOME SUMMARY</div>
            <div className="mock-perf-row"><span className="mock-perf-row-label">Total Return</span><span className="mock-perf-row-value">2870.02%</span></div>
            <div className="mock-perf-row"><span className="mock-perf-row-label">Net P/L</span><span className="mock-perf-row-value">USDT287,001.74</span></div>
            <div className="mock-perf-row"><span className="mock-perf-row-label">Trades</span><span className="mock-perf-row-value">31</span></div>
            <div className="mock-perf-row"><span className="mock-perf-row-label">Win Rate</span><span className="mock-perf-row-value">45% <span className="mock-perf-row-value muted">(14W / 17L)</span></span></div>
          </div>
        </div>

        <div className="mock-perf-grid">
          <div className="mock-perf-card">
            <div className="mock-perf-card-title">RISK-ADJUSTED METRICS</div>
            <div className="mock-perf-row"><span className="mock-perf-row-label">Sharpe Ratio</span><span className="mock-perf-row-value">0.83</span></div>
            <div className="mock-perf-row"><span className="mock-perf-row-label">Profit Factor</span><span className="mock-perf-row-value green">2.13</span></div>
            <div className="mock-perf-row"><span className="mock-perf-row-label">Expectancy</span><span className="mock-perf-row-value">USDT9,258.12</span></div>
            <div className="mock-perf-row"><span className="mock-perf-row-label">Payoff Ratio</span><span className="mock-perf-row-value">2.58</span></div>
            <div className="mock-perf-chart-caption">Returns driven by payoff asymmetry rather than consistency</div>
          </div>
          <div className="mock-perf-card">
            <div className="mock-perf-card-title">METRIC INTERPRETATION</div>
            <div className="mock-perf-interp-heading">CHARACTERISTICS</div>
            <div className="mock-perf-interp-text">Payoff-driven outcome structure</div>
            <div className="mock-perf-interp-heading">IMPLICATIONS</div>
            <div className="mock-perf-interp-text">Behaviour and drawdown analysis required for assessment</div>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">The Performance Metrics panel from a real backtest run on Quanthop.</div>
    </div>
  );
}
